import "breadcrumbs-pattern/dist/main.css";
import chevronLeftSmall from "../../../../public/assets/images/chevronleftsmall.svg";
import chevronRightSmall from "../../../../public/assets/images/chevronrightsmall.svg";
import './BreadCrumbs.css'
const BreadCrumbs = ({
  previousPage,
  currentPage,
  onPreviousClick,
  stackOnMobile = false,
}: {
  previousPage?: string;
  currentPage?: string;
  onPreviousClick?: () => void;
  stackOnMobile?: boolean;
}) => {
  const hasCurrent = !!(currentPage && String(currentPage).trim().length > 0);

  return (
    <div className="mobile-margin lg:!mt-[60px] "> 
      <nav
        aria-label="Breadcrumbs"
        className="ds-breadcrumbs ds-foundation text-[13px]! desktop:text-[14px]!"
        data-ds-theme="vessel"
        data-ds-variant="basic"
        data-ds-version="2"
        data-ref="0"
      >
        <ul className={`ds-breadcrumbs__list flex items-center gap-2 whitespace-nowrap overflow-x-auto md:flex-wrap md:whitespace-normal ${stackOnMobile ? 'mobile:!flex-col mobile:!items-start mobile:!gap-0 tablet:!flex-row tablet:!items-center desktop:!flex-row desktop:!items-center' : ''}`}>
          {hasCurrent ? (
            <>
              <li className={`inline-flex items-center ${stackOnMobile ? 'mobile:!w-full tablet:!w-auto desktop:!w-auto' : ''}`}>
                <button
                  type="button"
                  onClick={() => {
                    onPreviousClick?.();
                  }}
                  className={`underline cursor-pointer bg-transparent border-none p-0 ${stackOnMobile ? 'mobile:!flex mobile:!flex-col mobile:!items-start tablet:!inline desktop:!inline' : ''}`}
                  style={{color: 'rgb(0, 116, 173)', appearance: 'none'}}
                >
                  <span className={stackOnMobile ? 'mobile:!mb-1 tablet:!mb-0 desktop:!mb-0' : ''}>{previousPage}</span>
                  <img
                    aria-hidden="true"
                    className={`ds-breadcrumbs__chevron-forward inline-block align-middle w-4 h-4 filter invert-0 text-[#0D1C3D] !relative sm:!top-0 ${stackOnMobile ? 'mobile:!hidden tablet:!inline-block desktop:!inline-block' : ''}`}
                    src={chevronRightSmall}
                    alt=""
                    height="16px"
                    width="16px"
                  />
                </button>
              </li>
              <li className={`inline-flex items-center ${stackOnMobile ? 'mobile:!flex mobile:!items-start mobile:!gap-2 tablet:!inline-flex tablet:!items-center desktop:!inline-flex desktop:!items-center' : ''}`}>
                <div className={stackOnMobile ? 'mobile:!flex mobile:!items-start mobile:!gap-2 tablet:!inline desktop:!inline' : ''}>
                  {stackOnMobile && (
                    <img
                      aria-hidden="true"
                      className="mobile:!inline-block mobile:!mt-[2px] tablet:!hidden desktop:!hidden"
                      src={chevronRightSmall}
                      alt=""
                      height="16px"
                      width="16px"
                    />
                  )}
                  {!stackOnMobile && (
                    <img
                      aria-hidden="true"
                      className="mobile-only ds-breadcrumbs__chevron-back"
                      src={chevronRightSmall}
                      alt=""
                      height="16px"
                      width="16px"
                    />
                  )}
                  {currentPage}
                </div>
              </li>
            </>
          ) : (
            <>
              <li className="inline-flex items-center w-full sm:inline-flex sm:w-auto">
                <button
                  type="button"
                  onClick={() => {
                    onPreviousClick?.();
                  }}
                  className="underline cursor-pointer bg-transparent border-none p-0 block w-full sm:inline-block sm:w-auto"
                  style={{color: 'rgb(0, 116, 173)', appearance: 'none'}}
                >
                  <img
                    aria-hidden="true"
                    className="ds-breadcrumbs_chevron-back inline-block"
                    src={chevronLeftSmall}
                    alt="chevron left"
                    height="16px"
                    width="16px"
                  />
                  {previousPage}
                </button>
              </li>
              <li className="inline-flex items-center">{currentPage}</li>
            </>
          )}
        </ul>
      </nav>
    </div>
  );
};

export default BreadCrumbs;
